/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Partner_Admin_Commission_Void_Reason_ShownInputs */



/**
* | output |
* | --- |
* | "Reason: {reason}" |
*
* @param {Partner_Admin_Commission_Void_Reason_ShownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_void_reason_shown = /** @type {((inputs: Partner_Admin_Commission_Void_Reason_ShownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Void_Reason_ShownInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Grund: ${i?.reason}`)
	return /** @type {LocalizedString} */ (`Reason: ${i?.reason}`)
});